/**
 * Shared GET /offices/ query-string builder for client-scoped name search.
 * Used by invoice office validation and Additional Fields modal loaders.
 */

/**
 * @param {string} searchQuery - Raw search text (slashes stripped like legacy loaders).
 * @param {string|number|null|undefined} idClient - Tenant client id for scoping.
 * @returns {string} Path suffix after `/offices/` (includes leading `?`).
 */
export function buildOfficesSearchPath(searchQuery, idClient) {
    const val = String(searchQuery ?? '').trim().replace(/\//g, '');
    const filters = [{ id: 'search', value: val }, { id: 'id_client', value: idClient }];
    const sorting = [{ id: 'name', desc: false }];
    return `?filters=${encodeURIComponent(JSON.stringify(filters))}&sorting=${encodeURIComponent(JSON.stringify(sorting))}`;
}
